import { LogLevel } from 'amazon-chime-sdk-js';

const CHIME_LOG_LEVEL_BY_NAME: Record<string, LogLevel> = {
  OFF: LogLevel.OFF,
  ERROR: LogLevel.ERROR,
  WARN: LogLevel.WARN,
  INFO: LogLevel.INFO,
  DEBUG: LogLevel.DEBUG,
};

export const resolveChimeLogLevel = (): LogLevel => {
  const configuredLevel =
    import.meta.env.VITE_CHIME_LOG_LEVEL?.trim().toUpperCase();

  if (!configuredLevel) {
    return LogLevel.WARN;
  }

  return CHIME_LOG_LEVEL_BY_NAME[configuredLevel] ?? LogLevel.WARN;
};
